window.GridHelper = function(){};

(function ($) {

    GridHelper.createGrid = function(params) {

        var containerId = params['containerId'],
            pagerId = params['pagerId'],
            loadUrl = params['loadUrl'],
            columnNames = params['columnNames'],
            columnProps = params['columnProps'],
            title = params['title'],
            data = params['data'],
            rowSelHandler = params['rowSelHandler'],
            doubleClickHandler = params['doubleClickHandler'],
            rightClickHandler = params['rightClickHandler'],
            onSelectAll = params['onSelectAll'],
            width = params['width'] == null ? '100%' : params['width'],
	        autoWidth = params['width'] == null,
            height = params['height'] == null ? '100%' : params['height'],
	        rowList = params['rowList'] == null ? [10, 20, 30, 50, 100, 1000] : params['rowList'],
	        rowNum = params['rowNum'] == null ? 30 : params['rowNum'],
	        multiselect = params['multiselect'] == null ? false : params['multiselect'],
            sortName = params['sortName'] == null ? columnProps[0]['name'] : params['sortName'],
            sortOrder = params['sortOrder'] == null ? 'asc' : params['sortOrder'],
            loadOnce = params['loadOnce'] == null ? false : params['loadOnce'],
            onClickGroup = params['onClickGroup'] == null ? null : params['onClickGroup'],
            subGrid = params['subGrid'] == null ? false : params['subGrid'],
            subGridRowExpanded = params['subGridRowExpanded'] == null ? null : params['subGridRowExpanded'],
            beforeSelectRow = params['beforeSelectRow'] == null ? null : params['beforeSelectRow'],
            searchOnEnter = params['searchOnEnter'] == null ? false : params['searchOnEnter'],
            page = params['page'] == null ? 1 : params['page'],
            grouping = params['grouping'] == null ? false : params['grouping'],
            groupingView = params['groupingView'] == null ? {groupField:[],groupOrder:[], groupText:[],groupColumnShow:[],groupSummary:[], showSummaryOnHide: false, sortitems:[], sortnames:[], summary:[],summaryval:[], plusicon: 'ui-icon-circlesmall-plus', minusicon: 'ui-icon-circlesmall-minus'} : params['groupingView'],
            selectedItemsViewer = params['selectedItemsViewer'] == null ? false : params['selectedItemsViewer'];

        if(data === undefined || data == null){
            data = {};
        }

        var grid = jQuery('#' + containerId).jqGrid({
            //scroll:true,
            //scrollrows:true,
            url:loadUrl,
            datatype:"json",
            mtype:"GET",
            colNames:columnNames,
            colModel:columnProps,
            pager:'#' + pagerId,
            page: page,
            rowNum:rowNum,//30,
            rowList:rowList,//[10, 20, 30],
            caption:title,
            height: height,
            autoheight:true,
            width: width,
            autowidth:autoWidth,
            shrinkToFit : true,
            altRows:true,
            altclass : "grid_alt_row",
            forceFit:true,
            //scrollOffset: 20,
            postData:data,
            sortname: sortName,
            sortorder: sortOrder,
            viewrecords:true,
            multiselect:multiselect,
            //multiboxonly:true,
            //multikey: 'shiftKey',
            sortable: true,
            loadonce:loadOnce,
            ignoreCase: true,
            onClickGroup: onClickGroup,
            subGrid : subGrid,
            subGridRowExpanded: subGridRowExpanded,
            onRightClickRow: rightClickHandler,
            onSelectAll: onSelectAll,
            searchOnEnter: searchOnEnter,

                /*function(rowid, iRow, iCol, evt){
                debug.log('right', rowid, iRow, iCol, evt);
                evt.preventDefault();

                return false;
            },*/
            /*
             editable: true,
            cellEdit: true,
            cellsubmit: 'clientArray',
            afterEditCell: function (id,name,val,iRow,iCol){
                if(name=='invdate') {
                    jQuery("#"+iRow+"_invdate","#celltbl").datepicker({dateFormat:"yy-mm-dd"});
                }
            },
            afterSaveCell : function(rowid,name,val,iRow,iCol) {

                if(name == 'desc') {
                    var desc = jQuery("#" + containerId).jqGrid('getCell',rowid,iCol-1);
                    alert('Change desc to => ' + desc);


                    //jQuery("#celltbl").jqGrid('setRowData',rowid,{total:parseFloat(val)+parseFloat(amtval)});
                }
            },
            */
            jsonReader:{
                root:"rows",
                page:"page",
                total:"total",
                records:"records",
                repeatitems:false,
                id:"idx"
            },
            grouping: grouping,
            groupingView: groupingView,
            gridComplete:function () {
                $('#' + containerId).trigger('_gridComplete');

                Hades.refreshLayout();
            },
            loadComplete:function (data, response) {
                Hades.refreshLayout();
                
                $.fancybox.update();

                if(Hades.isTouch()){
                    $('#' + containerId + ' table.workflow_status').each(function(index, elem){
                        $(elem).closest('td[role=gridcell]').addClass('no_swipe');
                    });

                    $('#' + containerId + ' td[role=gridcell]:not(.no_swipe)').swipe({
                        //Generic swipe handler for all directions
                        swipeRight:function(event, direction, distance, duration, fingerCount) {
                            if(event.target){
                                $(event.target).closest('tr').trigger('dblclick');
                            }

                            //debug.log('You swiped right: ', event, direction, distance, duration, fingerCount);
                        },
                        tap:function(event, direction, distance, duration, fingerCount) {
                            if(event.target){
                                $(event.target).closest('tr').trigger('click');
                            }

                            //debug.log('You tapped: ', event, direction, distance, duration, fingerCount);
                        },
                        //Default is 75px, set to 0 for demo so any distance triggers swipe
                        threshold:10
                    });
                }

                //$('#' + containerId).fadeIn();
	            $('#' + containerId).trigger('dataChanged');
            },
            onSelectRow: rowSelHandler,
            ondblClickRow: doubleClickHandler,
            beforeSelectRow: beforeSelectRow
        });

        if(pagerId != null){
            grid.jqGrid("navGrid", '#' + pagerId, {
                "search":false,
                "refresh":true,
                "del":false,
                "add":false,
                "edit":false
            }, {}, {}, {
                "closeOnEscape":true
            });
        }

        if(params['filterBar'] == true){
            grid.jqGrid('filterToolbar', {searchOnEnter: searchOnEnter});

            $('th[role=columnheader]').addClass('bootstrap');
            $('th[role=columnheader] select').addClass('input_grad')
                .css('height', '30px')
                .css('width', '98%')
                .css('font-size', '13px')
                .css('margin', '3px 0');

            $('th[role=columnheader] input')
                .addClass('input_grad')
                .css('height', '27px')
                .css('font-size', '13px')
                .css('margin', '3px 0');
        }

        jQuery("#"+containerId).jqGrid('bindKeys', {"onEnter":doubleClickHandler} );

        /*
         // Add filter bar
         jQuery('#' + containerId).jqGrid('filterToolbar');

         // Add filter button
         jQuery('#' + containerId).jqGrid('navButtonAdd', '#' + pagerId, {
         caption:"Filter",
         title:"Open Filter Toolbar",
         buttonicon:'ui-icon-pin-s',
         onClickButton:function () {
         grid[0].toggleToolbar();
         }
         });

         // Hide filter bar
         grid[0].toggleToolbar();
         */

        // FIX 20px : Check why this element style is set with 'width = 20px'
        $('#' + pagerId + '_left').removeAttr('style');

        if(selectedItemsViewer){
            GridHelper.addSelectedItemsViewer();
        }

        return grid;
    };

    GridHelper.addSelectedItemsViewer = function(gridId, options){

    };

    GridHelper.alterPostData = function(gridId, params, vals) {

        var newData, currData;

        currData = $('#' + gridId).getGridParam('postData');
        if(currData){
            newData = currData;
        } else {
            newData = {};
        }

        for (var i = 0; i < params.length; i++) {
            newData[params[i]] = vals[i];
        }

        $('#' + gridId).setGridParam({postData:newData});
    };

    GridHelper.alterPostDataAndReloadGrid = function(gridId, params, vals) {
        GridHelper.alterPostData(gridId, params, vals);

        $('#' + gridId).trigger("reloadGrid");
    };

    /* Custom formaters
     /***********************************************************************/
    GridHelper.colorCell = function(cellvalue, options, rowObject) {

        var bgColor = options.colModel.colors[rowObject[options.colModel.field]] || 'transparent';
        var text = rowObject[options.colModel.fieldTxt] || '';

        var val = '<div class="color_cr" style="background-color: ' + bgColor + ';"><p title="'+text+'">'+text+'</p></div>';

        return val;
    };

    GridHelper.colorCellBG = function(cellvalue, options, rowObject) {

        //var bgColor = options.colModel.colors[rowObject[options.colModel.field]] || 'transparent';
        var bgColor = rowObject[options.colModel.field] || 'transparent';        
        
        var val = '<div class="wf_icon color_cr" style="background-color: ' + bgColor + ';"></div>';

        return val;
    };

    GridHelper.imageFormat = function(cellvalue, options, rowObject) {
        var val = '';

        if (cellvalue != null || cellvalue != '') {
            val = '<img src="' + cellvalue + '" class="photo" style="margin-top: 2px;" />';
        }

        return val;
    };

    GridHelper.comboBoxFormat = function(cellvalue, options, rowObject) {
        // $(\'#' + id + ' option:selected\').val()
        // options.colModel.episId
        // options.rowId
        // onchange="Hades.loadShortcut($('#' + $(this) + ' option:selected').val(),' + rowObject.id + ', ' + rowObject.episodeId + ');"

        var id = options.colModel.name + '_' + options.rowId;
        var val = '<select id="' + id + '" class="cb_actions" style="width: 128px;" >';
        var itemsLen = cellvalue.length;
        var action = null;

        if(!(itemsLen > 0)){
            return '';
        }

        val += '<option></option>'
        for (i = 0; i < itemsLen; i++) {
            action = cellvalue[i];
            val += '<option value="' + action.url + '"';

            // Select option
            if (action.selected == true) {
                val += '" selected="selected" ';
            }

            val += '>' + action.title + '</option>';
        }

        val += '</select>';

        return val;
    };

    GridHelper.detailBlockFormat = function(cellvalue, options, rowObject) {
        // $(\'#' + id + ' option:selected\').val()
        // options.colModel.episId
        // options.rowId
        // onchange="Hades.loadShortcut($('#' + $(this) + ' option:selected').val(),' + rowObject.id + ', ' + rowObject.episodeId + ');"

        if(cellvalue == null || cellvalue == ''){
            return '';
        }

        var elemGroups = cellvalue.split('|'), elemGroup, val = '';
        var itemsLen = elemGroups.length;

        //val = '<ul class="db_holder">';
        val = '';
        for (i = 0; i < itemsLen; i++) {
            elemGroup = elemGroups[i].split(':');
            //val += '<li class="rounded_border db_block">';
            val += '<span class="db_block_label">' + elemGroup[0] + '</span>';
            val += ': <span class="db_block_value">' + elemGroup[1] + '; </span>';
            //val += '</li>';
        }
        //val += '</ul>';
        val += '';

        return val;

        /*
        var id = options.colModel.name + '_' + options.rowId;
        var val = '<select id="' + id + '" class="cb_actions" style="width: 128px;" >';
        var itemsLen = cellvalue.length;
        var action = null;

        if(!(itemsLen > 0)){
            return '';
        }

        val += '<option></option>'
        for (i = 0; i < itemsLen; i++) {
            action = cellvalue[i];
            val += '<option value="' + action.url + '"';

            // Select option
            if (action.selected == true) {
                val += '" selected="selected" ';
            }

            val += '>' + action.title + '</option>';
        }

        val += '</select>';
        */

    };

    GridHelper.iconFormat = function(cellvalue, options, rowObject) {

        var val = '';

        if(cellvalue && cellvalue.length > 0){
            val = '<div class="' + cellvalue + '" title="' + rowObject[options.colModel.icon_title] + '"></div>';
        }

        return val;
    };

    GridHelper.blockFormat = function(cellvalue, options, rowObject){
        debug.log('rowObject',rowObject);

        var val = '';
        var bg = 'transparent';

           if (rowObject.other_wf_id) {
                var _icon = rowObject.other_icon + ' static';

               val = $.tmpl("iconCellTpl", [{grid:options.colModel.gridId,
                   column: options.colModel.name,
                   wf_id:rowObject.other_wf_id,
                   wf_status_id:rowObject.other_wf_status_id,
                   path:rowObject.other_path,
                   patient_id: rowObject.patient_id,
                   task_id: rowObject.inpatient_id,
                    treatment_id: rowObject.treatment_id,
                   //task_id:rowObject[taskIdCol],
                   sh_id: rowObject.other_shortcut_id,
                   bg_color:bg,
                   icon: _icon}]).html();


           }
        return val;


    };


    GridHelper.workflowBlockFormat = function(cellvalue, options, rowObject) {

        var val = '', useTimer = false, taskIdCol, wfId = parseInt(rowObject.wf_id), wfStatusId = parseInt(rowObject.wf_status_id);

        if(options.colModel.taskIdCol){
            taskIdCol = options.colModel.taskIdCol;
        } else {
            taskIdCol = 'task_id';
        }

	    /* TODO : STATUS_STR */
	    if((wfId == 1 || wfId == 2 || wfId == 8 || wfId == 31 || wfId == 33)
		    && (wfStatusId == 1 || wfStatusId == 2 || wfStatusId == 30 || wfStatusId == 58 || wfStatusId == 63)){
		    useTimer = true;
	    }

        if(!rowObject.task_date){
            useTimer = false;
        }

	    // Timer
	    if(useTimer){
            debug.log('GridHelper.workflowBlockFormat : Timer : row', rowObject);

		    var props = GlobalFn.getCellProps(rowObject.task_date, rowObject.server_date);
		    var displayTime = new Date(Math.abs(props.timeDiff));
            var displayTimeStr

            if (Math.abs(props.timeDiff) < 86400000 /* 24*3600*1000 */) {
                displayTimeStr = (displayTime.getUTCHours() < 10 ? "0" + displayTime.getUTCHours() : displayTime.getUTCHours()) + ':'
                    + (displayTime.getUTCMinutes() < 10 ? "0" + displayTime.getUTCMinutes() : displayTime.getUTCMinutes())
            } else {
                displayTimeStr = Math.floor(((Math.abs(props.timeDiff) / 1000) / 3600) / 24) + ' dia(s)';
            }
                
            var delayStr = (rowObject.diff_str != null) ? rowObject.diff_str : displayTimeStr;

		    val = $.tmpl("workflowCellTimerTpl", [{grid:options.colModel.gridId,
			    column: options.colModel.name,
			    wf_id:rowObject.wf_id,
			    wf_status_id:rowObject.wf_status_id,
			    task_id:rowObject[taskIdCol],
			    bg_color:props.bgColor,
                date:rowObject.task_date,
                //delay:displayTimeStr
                delay:delayStr}]).html();			    
	    }
	    // Icon
	    else {
            var bg = 'transparent', _icon = rowObject.wf_status_icon;

            if (wfStatusId == 5 && rowObject.arrival_date) {
                bg = GlobalFn.getWaitingCellProps(rowObject.server_date, rowObject.arrival_date, [60, 15, 1]);
               _icon = rowObject.wf_status_icon + ' static';
            }else if ( wfId == 44 && wfStatusId == 95 && rowObject.triage_date && rowObject.waiting_time_scale){

                var waiting_time_scale = rowObject.waiting_time_scale.split(";");
                if (waiting_time_scale.length <= 0){
                    waiting_time_scale = [60, 15, 1]
                }

                bg = GlobalFn.getWaitingCellProps(rowObject.server_date, rowObject.triage_date_desc, waiting_time_scale);
                _icon = rowObject.wf_status_icon + ' static';
            }

		    val = $.tmpl("workflowCellTpl", [{grid:options.colModel.gridId,
			    column: options.colModel.name,
			    wf_id:rowObject.wf_id,
			    wf_status_id:rowObject.wf_status_id,
			    task_id:rowObject[taskIdCol],
                bg_color:bg,
			    icon: _icon}]).html();
	    }

        return val;
    };

	GridHelper.toggleSelectionFormat = function(cellvalue, options, rowObject) {
		var slotId = rowObject[options.colModel.name + '_id'];

		var idStr = '';
		if(slotId != null){
			idStr = 'id=' + slotId;
		}

		var selectionClass = cellvalue == true ? 'not_free_selection' : 'free_selection';

		var val = '<div ' + idStr + ' class="selection_toggle ' + selectionClass + '" style="width: 100%; height: 100%; cursor: pointer;"></div>';

		return val;
	};

	GridHelper.ButtonsFormat = function(cellvalue, options, rowObject) {

		var val = '<div style="width: 42px; height: 42px; cursor: pointer;">';
		var action, params, param;

		for(var i = 0; i < rowObject.actions.length; i++){
			action = rowObject.actions[i];

			params = '{';
			for(var j = 0; j < action.params.length; j++){
				param = action.params[j];

				if(j > 0){params += ', ';}

				params += param;
				params += ':\'';
				params += rowObject[param];
				params += '\'';
			}
			params += '}';

			if(action.url != undefined && action.url != null){
				val += '<div onclick="Hades.postRequest(\'' + action.url + '\', ' + params + ', ' + action.callback + ')" style="height: 42px;" align="center"><div class="k_btn ' + action.button + '"></div></div>';
			} else {
				val += '<div style="height: 42px;" align="center"><div onclick="' + action.callback + '(this, ' + params + ');" class="k_btn ' + action.button + '"></div></div>';
			}
		}

		val += '</div>';

		return val;
	};

	GridHelper.checkboxFormat = function(cellvalue, options, rowObject) {

		var checked = '';
		if(cellvalue == 't' || cellvalue == '1'){
			checked = 'checked="checked"';
		}

		//var val = '<div style="width: 100%; height: 100%; cursor: pointer;">';

		var val = '<input type="checkbox" ' + checked + ' disabled="disabled">';

		//val += '</div>';

		return val;
	};

    GridHelper.checkboxUnformat = function(cellvalue, options, rowObject) {
        if(cellvalue == 'true' || cellvalue == 't' || cellvalue == '1'){
            return "t";
        } else {
            return "f";
        }
    };

    GridHelper.textCompare = function(value, colname) {

        return true;
    };


    GridHelper.groupHeaderFormatter = function(val, name, record) {
        debug.log('groupHeaderFormatter', val, name, record);

        //return 'PIROCAS';
        return 'NOTIMPLEMENTED';

        var fields = options.colModel.cols, separators = options.colModel.separators, header = '', colFormat = options.colModel.colFormat;

        debug.log('groupHeaderFormatter', options.colModel.cols, options.colModel.separators, options.colModel.colFormat);

        $.each(fields, function(index, elem){
            debug.log(index, elem);
            header += colFormat[index].replace('#VAL#', rowObject[elem]) + separators[index];
        });

        debug.log(header);

        return header;
    };

	GridHelper.photoTwoLinesCellRender = function(cellvalue, options, rowObject) {


		var title = '';
		if(options.colModel.firstLine && rowObject[options.colModel.firstLine]){
            if (options.colModel.is_med_patient && rowObject[options.colModel.is_med_patient] == "t"){
                title += rowObject[options.colModel.firstLine] + ' ' + GlobalTranslations['APP_LABEL.2626'];
            }else{
                title += rowObject[options.colModel.firstLine];
            }
		}
		if(options.colModel.secondLine && rowObject[options.colModel.secondLine]){
			title += "&#10;" + rowObject[options.colModel.secondLine];
		}


		// Open tags
		var val = '<table title="' + title + '" cellpadding="0" cellspacing="0" style="margin: 0; border: none;"><tr>';

		// Photo
		if(options.colModel.photo && rowObject[options.colModel.photo]){
			val += '<td valign="middle" style="border: none;"><img src="' + rowObject[options.colModel.photo] + '" class="photo" style="margin-top: 2px;" /></td>';
		}

		val += '<td valign="middle" style="border: none;">';

		// First Line
		if(options.colModel.firstLine && rowObject[options.colModel.firstLine]){
		    if (options.colModel.is_med_patient && rowObject[options.colModel.is_med_patient] == "t"){
		        val += '<div style="font-weight: bold;">' + rowObject[options.colModel.firstLine] + ' <i style=color:darkgray font-size: smaller;>' + GlobalTranslations['APP_LABEL.2626'] + '</i>' + '</div>';
            }else {
                val += '<div style="font-weight: bold;">' + rowObject[options.colModel.firstLine] + '</div>';
            }
		}

		// Second Line
		if(options.colModel.secondLine && rowObject[options.colModel.secondLine]){
			val += '<div style="font-style: italic;">' + rowObject[options.colModel.secondLine] + '</div>';
		}

		// Close tags
		val += '</td></tr></table>';


		return val;
	};

    GridHelper.twoLinesCellRender = function(cellvalue, options, rowObject) {

        var parts, firstLine = '', secondLine = '', data = '';

        if (cellvalue == null || cellvalue == undefined){
            cellvalue = '';
        }

        if(options.colModel.separator){
                parts = cellvalue.split(options.colModel.separator);
                firstLine = parts[0];

                if (parts.length > 1){
                    secondLine = parts[1];
                }

                for (var i = 2; i < parts.length; i++) {
                    data += ' data-p' + (i - 1) + '="' + parts[i] + '"';
                }
        } else {
            firstLine = cellvalue;
        }

        // Open tags
        var val = '<div '+ data +' >';
        // First Line
        val += '<div style="font-weight: bold;">' + firstLine + '</div>';
        // Second Line
        val += '<div style="font-style: italic;">' + secondLine + '</div>';
        // Close tags
        val += '</div>';

        return val;
    };
	GridHelper.iconTwoLinesCellRender = function(cellvalue, options, rowObject) {

		var title = '';
		if(options.colModel.firstLine && rowObject[options.colModel.firstLine]){
			title += rowObject[options.colModel.firstLine];
		}
		if(options.colModel.secondLine && rowObject[options.colModel.secondLine]){
			title += "&#10;" + rowObject[options.colModel.secondLine];
		}

		// Open tags
		var val = '<table title="' + title + '" cellpadding="0" cellspacing="0" style="margin: 0; border: none;"><tr>';

		// Photo
		if(options.colModel.icon && rowObject[options.colModel.icon]){
			val += '<td valign="middle" style="border: none;"><div class="' + rowObject[options.colModel.icon] + '"></div></td>';
		}

		val += '<td valign="middle" style="border: none;">';

		// First Line
		if(options.colModel.firstLine && rowObject[options.colModel.firstLine]){
			val += '<div style="font-weight: bold;">' + rowObject[options.colModel.firstLine] + '</div>';
		}

		// Second Line
		if(options.colModel.secondLine && rowObject[options.colModel.secondLine]){
			val += '<div style="font-style: italic;">' + rowObject[options.colModel.secondLine] + '</div>';
		}

		// Close tags
		val += '</td></tr></table>';

		return val;
	};

    GridHelper.iconTwoLinesCellRenderUnformat = function(cellvalue, options, cell) {
        //debug.log('iconTwoLinesCellRenderUnformat', cellvalue, options, cell);

        return '';
    };

	GridHelper.textCellRender = function(cellvalue, options, rowObject) {

		if(cellvalue == null || cellvalue == undefined){
			cellvalue = '';
		}

		// Open tags
		//var val = '<div title="' + cellvalue + '" style="width: 100%; max-height: 40px; overflow-y: hidden;">';

		// Content
		//val += cellvalue;

		// Close tags
		//val += '</div>';

		var val = '<div style="width: 100%; /*max-height: 30px; overflow-y: hidden;*/"><p title="' + cellvalue + '" style="margin: 0px; white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">' + cellvalue + '</p></div>';
		return val;
    };
    
    GridHelper.interactionsNotificationRender = function(cellvalue, options, rowObject) {
        
		if(rowObject.count_patient_unread_comments > 0){
			var val = '<span style="background-color:orange; padding: 1px 3px; border-radius: 100px; z-index: 3; font-size: 3px; margin: 3px;"></span><span>'+ rowObject.document_number +'</span>';
		}else{
            var val = '<span style="margin-left: 12px;">' + rowObject.document_number +'</span>';
        }

		return val;
    };
    
    GridHelper.reimbursementRequisitionsNotificationRender = function(cellvalue, options, rowObject) {
		if(rowObject.created_in_portal == true && rowObject.flg_read == false){
			var val = '<span style="background-color:orange; padding: 1px 3px; border-radius: 100px; z-index: 3; font-size: 3px; margin: 3px;"></span><span>'+ rowObject.document_number +'</span>';
		}else{
            var val = '<span style="margin-left: 12px;">' + rowObject.document_number + '</span>';
        }

		return val;
	};

    GridHelper.inlineActionsCellRender = function(cellvalue, options, rowObject) {

        var val = '<div style="margin-left:8px;">', button, style;

        for(var i = 0; i < options.colModel.buttons.length; i++){
            button = options.colModel.buttons[i];
            if(button.style){
                style = button.style;
            } else {
                style = '';
            }

            val += '<div title="' + button.title + '" style="float: left; cursor: pointer; display: block;" class="ui-pg-div ui-inline-edit" onclick="' + button.callbackFn + '(' + options.rowId + ');" onmouseover="jQuery(this).addClass(\'ui-state-hover\');" onmouseout="jQuery(this).removeClass(\'ui-state-hover\')"><span class="' + button.icon + '" style="' + style + '"></span></div>';
        }

        val += '</div>';

        return val;
    };

    GridHelper.dateRender = function(cellvalue, options, rowObject) {

        if(cellvalue == null || cellvalue == undefined){
			cellvalue = '';
		}

		// Open tags
		//var val = '<div title="' + cellvalue + '" style="width: 100%; max-height: 40px; overflow-y: hidden;">';

		// Content
		//val += cellvalue;

		// Close tags
		//val += '</div>';

        cellvalue = GlobalFn.fromServerToLocalString(cellvalue)

		var val = '<div style="width: 100%; /*max-height: 30px; overflow-y: hidden;*/"><p title="' + cellvalue + '" style="margin: 0px; white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">' + cellvalue + '</p></div>';
		return val;
    };

})(jQuery);